import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import logger from 'loglevel';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore todo: проблема при билде
import { Deferred } from 'class-deferred';
import { BaseBroker } from "./BaseBroker";
import { wrapAck } from "./helpers";

/**
 * Брокер для передачи команд через WebSocket-сервер
 */
export var WsClientBroker = /*#__PURE__*/function (_BaseBroker) {
  _inherits(WsClientBroker, _BaseBroker);
  var _super = _createSuper(WsClientBroker);
  function WsClientBroker() {
    var _this;
    _classCallCheck(this, WsClientBroker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "socket", void 0);
    _defineProperty(_assertThisInitialized(_this), "asyncSocket", new Deferred());
    return _this;
  }
  _createClass(WsClientBroker, [{
    key: "connect",
    value: function connect(socket) {
      logger.info('[WsClientBroker] Started');
      this.socket = socket;
      this.asyncSocket.resolve(socket);
      this.socket.on('connect', function () {
        return logger.info('[WsClientBroker] Connected');
      });
      this.socket.on('message', this.receive.bind(this));
      this.socket.on('disconnect', function () {
        return logger.info('[WsClientBroker] Disconnected');
      });
    }
  }, {
    key: "onReady",
    value: function () {
      var _onReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cb) {
        var socket;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.asyncSocket;
            case 2:
              socket = _context.sent;
              if (!socket.connected) {
                _context.next = 6;
                break;
              }
              cb();
              return _context.abrupt("return");
            case 6:
              socket.once('connect', cb);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onReady(_x) {
        return _onReady.apply(this, arguments);
      }
      return onReady;
    }()
  }, {
    key: "send",
    value: function send(msg, extra, ack) {
      try {
        var _this$socket;
        if (!this.socket) throw Error('Attempting to call send before connecting client socket');
        (_this$socket = this.socket).emit.apply(_this$socket, ['message', msg].concat(_toConsumableArray(wrapAck(ack))));
      } catch (err) {
        console.error('Unable to sendMessage, arguments are most likely not serializable');
        throw err;
      }
    }
  }]);
  return WsClientBroker;
}(BaseBroker);